import { render, staticRenderFns } from "./LeftTree.vue?vue&type=template&id=66ff43b4&scoped=true"
import script from "./LeftTree.vue?vue&type=script&lang=ts"
export * from "./LeftTree.vue?vue&type=script&lang=ts"
import style0 from "./LeftTree.vue?vue&type=style&index=0&id=66ff43b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff43b4",
  null
  
)

export default component.exports